import { render } from "./SetupModal.vue?vue&type=template&id=077a609b&ts=true"
import script from "./SetupModal.vue?vue&type=script&lang=ts"
export * from "./SetupModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__